<template>
    <div>
        <div class="form-group">
            <page-title :showTitle="false" :title="$t('calendar.title')"></page-title>
        </div>

        <calendar :viewType="viewType">

        </calendar>
    </div>
</template>

<script>
    import Calendar from '../../components/calendar/Calendar';
    import PageTitle from '../../components/common/PageTitle';

    export default {
        props: {
            viewType: String,
            details: {
                type: Boolean,
                default: false
            },
        },
        components: {
            Calendar,
            PageTitle
        },
        data() {
            return {
               
            }
        },
        methods: {
            
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
</style>
